import { render, staticRenderFns } from "./SamCard.vue?vue&type=template&id=6d9db44e&scoped=true&"
import script from "./SamCard.vue?vue&type=script&lang=js&"
export * from "./SamCard.vue?vue&type=script&lang=js&"
import style0 from "./SamCard.vue?vue&type=style&index=0&id=6d9db44e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9db44e",
  null
  
)

export default component.exports